module.exports = __webpack_public_path__ + "static/img/Aland.bf62c839.jpg";